import { HashRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import posthog from 'posthog-js';

import Footer from './components/Footer'
import Header from './components/Header'
import BrowseScreen from './browse/BrowseScreen';
import BroadcastScreen from './screens/BroadcastScreen';
import Banner from './components/Banner';
import store from './store';
import { filterBroadcastsByQuery } from './actions/broadcastActions';
import gaEvents from './events';
import { useSelector } from 'react-redux'
import React from 'react'

// The browse screen (/) brings its own header (src/browse/BrowseHeader);
// the legacy chrome only wraps the remaining routes.
function LegacyChrome(props) {
  const { pathname } = useLocation();
  if (pathname === '/') return null;
  return (
    <>
      <Header {...props} />
      <Banner messageShort={"New! Menu to filter by park or resort"} messageLong={"New! Menu to filter by park or resort"} />
    </>
  );
}

function App() {
  const [tagStatuses, setTagStatuses] = React.useState({
    'Unknown location': false,
  });

    // This function will toggle the value for a given key in the dictionary
  const toggleValue = key => {
    setTagStatuses({
      ...tagStatuses,
      [key]: !tagStatuses[key]
    });
  }

  // This function will add a new key-value pair to the dictionary if the key
  // is not already in the dictionary
  const registerKeyValuePair = (key, value) => {
    if (!(key in tagStatuses)) {
      setTagStatuses({
        ...tagStatuses,
        [key]: value
      });
    }
  }

  const onSearch = query => {
    store.dispatch(filterBroadcastsByQuery(query))
    gaEvents.broadcastFilterQuery(query)
    posthog.capture('broadcast_filter_query', { query })
  }

  const tags = useSelector(state => state.broadcastList.broadcasts.reduce((acc, broadcast) => {
    broadcast.tags.forEach(tag => {
      if (!acc.some(t => t.name === tag.name)) {
        acc.push(tag)
      }
    })
    acc.sort((a, b) => a.name.localeCompare(b.name))
    return acc
  }, []))

  return (
    <Router>
      <link rel="stylesheet" href="https://rsms.me/inter/inter.css"></link>
      <LegacyChrome
        onSearch={onSearch}
        tags={tags}
        tagStatuses={tagStatuses}
        setTagStatuses={setTagStatuses}
        toggleValue={toggleValue}
        registerKeyValuePair={registerKeyValuePair}
      />
      <main className='py-3'>
          <Routes>
            {/* C-1: new sectioned browse grid (src/browse/). The legacy
                BroadcastsGridScreen stays in place, just unrouted. */}
            <Route path='/' element={<BrowseScreen />} />
            <Route path='/stream/:id' element={<BroadcastScreen/>} />
          </Routes>
      </main>
      <Footer />
    </Router>
  );
}

export default App;
